import { UserAvatar } from '@/shared/features/user-avatar';
import { type QuizBankAuthor, type QuizBankStandard } from '../types';
import { QuizBankDivider } from './QuizBankDivider';
import { QuizBankStandardCode } from './QuizBankStandardCode';
interface QuizBankProblemCardFooterProps {
  standard: QuizBankStandard;
  author: QuizBankAuthor;
  onStandardClick?: (standard: QuizBankStandard) => void;
}

/**
 * 카드 하단 메타 — 작성자 | 영역 | 단원 | 성취기준 (Figma).
 * 영역·단원은 둘 다 서버가 주는 값이고, 미이행 문항이면 없어서 각각 생략한다.
 */
export const QuizBankProblemCardFooter = ({
  standard,
  author,
  onStandardClick
}: QuizBankProblemCardFooterProps) => {
  const areaName = standard.areaName;
  const unitName = standard.unitName;
  return <div className="flex w-full min-w-0 flex-wrap items-center gap-xs text-body-sm-medium text-neutral" data-sentry-component="QuizBankProblemCardFooter" data-sentry-source-file="QuizBankProblemCardFooter.tsx">
      <span className="flex min-w-0 items-center gap-3xs text-default">
        {/* avatarData 가 null 이면 UserAvatar 가 FallbackAvatar 를 그린다 */}
        <UserAvatar avatarData={author.avatarData} size="xxs" className="shrink-0" data-sentry-element="UserAvatar" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />
        <span className="truncate">{author.name}</span>
      </span>

      {areaName && <>
          <QuizBankDivider />
          <span className="shrink-0">{areaName}</span>
        </>}

      {unitName && <>
          <QuizBankDivider />
          <span className="truncate">{unitName}</span>
        </>}

      <QuizBankDivider data-sentry-element="QuizBankDivider" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />

      <QuizBankStandardCode code={standard.code} description={standard.description} onClick={() => onStandardClick?.(standard)} data-sentry-element="QuizBankStandardCode" data-sentry-source-file="QuizBankProblemCardFooter.tsx" />
    </div>;
};